export default __webpack_public_path__ + "static/media/C.a2ff0c8c.svg";